import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { RentalConditions } from './types/RentalConditions';

export default (makeCall: MakeCall) => (id: number) =>
  makeCall<RentalConditions>(
    'GET',
    `${APIV2_URL}/bookings/rental-conditions/id/${id}`,
  );
